<template>
    <div id="app">
        <h1>mrfclip</h1>
        <p>A polygon clipping library for Tcl&nbsp;
            <a href="https://github.com/shages/mrfclip" target="_blank">
            <img class="github-link" src="./assets/GitHub-Mark-32px.png" /></a>
        </p>
        <div class="channel">
            <poly-canvas></poly-canvas>
            <user-inputs></user-inputs>
        </div>
    </div>
</template>

<script>
import PolyCanvas from './components/PolyCanvas.vue'
import UserInputs from './components/UserInputs.vue'

export default {
  name: 'app',
  components: { PolyCanvas, UserInputs },
  data () {
    return {}
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.channel {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
}
.github-link {
    width: 16px;
    height: 16px;
    opacity: 0.5;
}
.github-link:hover {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// App.vue?699f5da8